import { createFileRoute } from "@tanstack/react-router";

import { AdminMemberRegisterPage } from "@/features/admin/member-register-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/member-register")({
  staticData: { crumb: { label: STATIC_LABELS.adminMemberRegister } },
  component: AdminMemberRegisterPage,
});
